import { render } from "./map-tab.vue?vue&type=template&id=952f8be8"
import script from "./map-tab.vue?vue&type=script&lang=js"
export * from "./map-tab.vue?vue&type=script&lang=js"

import "./map-tab.vue?vue&type=style&index=0&id=952f8be8&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-map/classic/map-tab.vue'],['render',render],['__file',"map-tab.vue"]])

export default __exports__